import React, { ChangeEvent } from 'react';
import { FicheAutoControleCritere } from '../../../store/types/FicheAutocontrole.Types';
import Rating from '@material-ui/lab/Rating';
import { Typography, withStyles } from '@material-ui/core';
import StarIcon from '@material-ui/icons/Star';
import StarOutlineIcon from '@material-ui/icons/StarBorderOutlined';


const StyledRating = withStyles({
  iconFilled: {
    color: '#7d1e4f',
  },
  iconHover: {
    color: '#7d1e4f',
  },
})(Rating);


interface PropsFromState {
    critere: FicheAutoControleCritere,
    updateCritere: Function,
    goBackStateHasChanged: Function
}

const RatingAutocontrole: React.FC<PropsFromState> = ({ critere, updateCritere, goBackStateHasChanged }) => {

    const handleRatingChange = (event: ChangeEvent<{}>, newValue: number | null) => {
        goBackStateHasChanged();
        critere.ratingValue = newValue as number;
        updateCritere(critere);
    }

    return (
        <div className="rating-container">
            <Typography className="rating-label" component="legend">Qualité de la prestation</Typography>
            <StyledRating
                name={`rating-customized-${critere.id}`}
                size="large"
                icon={<StarIcon style={{ fontSize: 40 }} />}
                emptyIcon={<StarOutlineIcon style={{ fontSize: 40, color: '#7d1e4f'}} />}
                value={(critere.ratingValue && critere.activated) ? critere.ratingValue : null}
                onChange={handleRatingChange}
                disabled={!critere.activated}
            />
        </div>
    );
};

export default RatingAutocontrole;